import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';

interface CurrentSiderState {
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
}

export const useSiderStore = create<CurrentSiderState>()(
  devtools(
    persist(
      (set) => ({
        isCollapsed: false,
        setIsCollapsed: (isCollapsed: boolean) => set({ isCollapsed }),
      }),
      {
        name: 'sider-storage',
        storage: createJSONStorage(() => localStorage),
      }
    ),
    {
      name: 'SiderStore',
      anonymousActionType: 'setIsCollapsed',
      store: 'SiderStore',
    }
  )
);
